import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const VEHICLE_BLOCK_CREATE_RESOURCE = "vehicle-block" as const;
export const VEHICLE_BLOCK_CREATE_API_PATH = `/v1/${VEHICLE_BLOCK_CREATE_RESOURCE}` as const;

export type VehicleBlockCreateBody =
  paths[typeof VEHICLE_BLOCK_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type VehicleBlockCreateResponse =
  paths[typeof VEHICLE_BLOCK_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useVehicleBlockCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleBlockCreateResponse, Error, VehicleBlockCreateBody>({
    mutationFn: async (vehicleBlock: VehicleBlockCreateBody) => {
      const response = await alphartisApiAxios.post<VehicleBlockCreateResponse>(
        VEHICLE_BLOCK_CREATE_API_PATH,
        vehicleBlock,
      );
      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_BLOCK_CREATE_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: ["vehicle"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["relocation-order"],
        }),
      ]);
    },
  });
};
